var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "date-picker-container" },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c(
            "mobile-button",
            {
              staticClass: "date-box",
              attrs: { color: "#808080" },
              on: { click: _vm.startClick }
            },
            [
              _c("span", { staticClass: "date-value" }, [
                _vm._v(_vm._s(_vm.startText))
              ]),
              _c("van-icon", {
                attrs: { "class-prefix": "mars-icon", name: "date" }
              })
            ],
            1
          ),
          _c("span", { staticClass: "separator" }, [_vm._v("~")]),
          _c(
            "mobile-button",
            {
              staticClass: "date-box",
              attrs: { color: "#808080" },
              on: { click: _vm.endClick }
            },
            [
              _c("span", { staticClass: "date-value" }, [
                _vm._v(_vm._s(_vm.endText))
              ]),
              _c("van-icon", {
                attrs: { "class-prefix": "mars-icon", name: "date" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showPopup,
            callback: function($$v) {
              _vm.showPopup = $$v
            },
            expression: "showPopup"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: { type: "date" },
            on: { confirm: _vm.onConfirm, cancel: _vm.onCancel },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }